import { ConditionAttribute } from 'shared/types/graphql';
import { MenuItemProps } from '@televet/kibble-ui/build/components/Menu/components/MenuItem';
import { errorDetails } from './AutomationValidation';
import { SendConditionBase } from './SendConditionBase';
import { SendConditionPatientAge } from './SendConditionPatientAge';

export const SEND_CONDITION_ATTRIBUTES = [
  ConditionAttribute.AppointmentTypeId,
  ConditionAttribute.ClinicRoomId,
  ConditionAttribute.ClinicEmployeeId,
  ConditionAttribute.SpeciesType,
  ConditionAttribute.PetAgeInYears,
  ConditionAttribute.CareMembershipStatus,
] as const;

export type SendConditionAttribute = typeof SEND_CONDITION_ATTRIBUTES[number];

export const isSendConditionAttribute = (value: unknown): value is SendConditionAttribute => {
  return SEND_CONDITION_ATTRIBUTES.includes(value as SendConditionAttribute);
};

export type TaggableSendConditionAttribute = Exclude<SendConditionAttribute, ConditionAttribute.PetAgeInYears>;

export type SendCondition<Attribute = SendConditionAttribute> = Attribute extends TaggableSendConditionAttribute
  ? SendConditionBase<Attribute>
  : SendConditionPatientAge;

export type SendConditions = {
  [Attribute in Extract<ConditionAttribute, SendConditionAttribute>]?: SendCondition<Attribute>;
};

export interface SendConditionItem {
  value: SendConditionAttribute;
  label: string;
}

// isActive propert cannot be set on the menu options
export interface TagBlockMenuOptions {
  [ConditionAttribute.AppointmentTypeId]: MenuItemProps[];
  [ConditionAttribute.ClinicRoomId]: MenuItemProps[];
  [ConditionAttribute.ClinicEmployeeId]: MenuItemProps[];
  [ConditionAttribute.SpeciesType]: MenuItemProps[];
}

export interface Tags extends Pick<MenuItemProps, 'label' | 'value' | 'isSelected'> {
  isActive: boolean;
  isDeleted: boolean;
}

export interface TagBlocks extends MenuItemProps {
  [ConditionAttribute.AppointmentTypeId]: Tags[];
  [ConditionAttribute.ClinicRoomId]: Tags[];
  [ConditionAttribute.ClinicEmployeeId]: Tags[];
  [ConditionAttribute.SpeciesType]: Tags[];
  [ConditionAttribute.CareMembershipStatus]: Tags[];
}

export const SendConditionErrorText = {
  [ConditionAttribute.AppointmentTypeId]: errorDetails.appointmentTypesEmpty.errorMessage,
  [ConditionAttribute.ClinicEmployeeId]: errorDetails.appointmentProvidersEmpty.errorMessage,
  [ConditionAttribute.ClinicRoomId]: errorDetails.appointmentRoomsEmpty.errorMessage,
  [ConditionAttribute.SpeciesType]: errorDetails.patientSpeciesEmpty.errorMessage,
  [ConditionAttribute.PetAgeInYears]: errorDetails.patientAgeEmpty.errorMessage,
  [ConditionAttribute.CareMembershipStatus]: errorDetails.careMembershipEmpty.errorMessage,
};
